$.fn.cookiesEnabled = function () {
  var $document = $(document);
  var enabled = navigator.cookieEnabled ? true : false;
  if (typeof navigator.cookieEnabled == 'undefined' && !enabled) {
    $document.cookie = 'testcookie';
    enabled = $document.cookie.indexOf('testcookie') != -1 ? true : false;
  }
  return enabled;
};
